import * as api from "@/api/project";
import { useQuery } from "react-query";

export function useGetProjectList() {
  const queryKey = ["projects"];
  return useQuery(queryKey, api.getProjectList);
}
